import React, { useEffect, useRef, useState } from "react";
import My3DWorld from "./My3DWorld";
import ToggleSwitch from "./ToggleSwitch";
import "./CSS_styles/heading.css";
import "./CSS_styles/home2d-sections.css";
import Home2D from "./Home2D";

function Topbar() {
  const [is3D, setIs3D] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [flashSection, setFlashSection] = useState("");
const [isNameDragging3D, setIsNameDragging3D] = useState(false);
  const flashTimer = useRef(null);
  


  useEffect(() => {
    const onSectionChange = (event) => {
      const section = event.detail?.section || "home";
      setActiveSection(section);
      setFlashSection(section);

      window.clearTimeout(flashTimer.current);
      flashTimer.current = window.setTimeout(() => {
        setFlashSection("");
      }, 5000);
    };

    window.addEventListener("sectionchange", onSectionChange);

    return () => {
      window.removeEventListener("sectionchange", onSectionChange);
      window.clearTimeout(flashTimer.current);
    };
  }, []);

  const scrollToSection = (sectionName) => {
  const target = document.querySelector(`[data-section="${sectionName}"]`);

  if (!target) return;

  target.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};

  const navClass = (sectionName, extra = "") => {
    const active = activeSection === sectionName ? "is-active" : "";
    const flash = flashSection === sectionName ? "is-flash" : "";
    return `nav-item ${extra} ${active} ${flash}`.trim();
  };

  return (
    <>
    
      <div className="heading-content">
        <div className="name">
          <div> ANKITH RUDRA</div>

        </div>

        <div className="nav-menu">

        <div
          className={navClass("home", "nav-home")}
          onClick={() => scrollToSection("home")}
        >
          HOME
        </div>

          <div
            className={navClass("about")}
            onClick={() => scrollToSection("about")}
          >
            About
          </div>

          <div
            className={navClass("skills")}
            onClick={() => scrollToSection("skills")}
          >
            Skills
          </div>

          <div
            className={navClass("ai-fun")}
            onClick={() => scrollToSection("ai-fun")}
          >
            Projects / Games
          </div>

          <div className="nav-3d">
            <div className="nav-item nav-3d-label no-hover">
              {is3D ? "Switch to 2D" : "Switch to 3D"}
            </div>

            <ToggleSwitch
              checked={is3D}
              onChange={setIs3D}
              label="Toggle 3D mode"
            />
          </div>

          <div
            className={navClass("contact", "contact")}
            onClick={() => scrollToSection("contact")}
          >
            Contact
          </div>

          
        </div>
      </div>

      

      <main className={`page-content ${isNameDragging3D ? "drag-over-topbar" : ""}`}>
  {is3D ? (
    <My3DWorld onNameDragChange={setIsNameDragging3D} />
  ) : (
    <Home2D />
  )}
</main>


{!is3D && (
  <div className="sticky-footer">
    <span>© 2026 Ankith Rudra.&nbsp;&nbsp;&nbsp;All Rights Reserved.</span>
  </div>
)}
</>
  );

}

export default Topbar;